import Vue from 'vue';
import vuetify from './plugins/vuetify';
import VueSweetalert2 from 'vue-sweetalert2';
import VueCookies from 'vue-cookies';
// Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css';

import App from './App';

Vue.use(VueSweetalert2);
Vue.use(VueCookies);

// set default config: restrict to the base path
VueCookies.config('1d', (process.env.BASE_URL || '/').replace(/\/+$/, ''));

import { store } from './store';
import { router } from './router';
import i18n from './i18n'

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
